/**
 * RESPONSIBILITY: one way to give.
 *
 * Rows, because how a church takes money changes - an app is added, a bank detail moves,
 * a Sunday basket stays. Each is a name, an explanation and somewhere to go, and may
 * carry a picture — the Zelle QR code — that opens full size to be scanned (R68).
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Paragraph, Link, Img, RenderOf } from '@framework/core/decorators';
import { LINK_HINT } from '../../hints';

@Row()
export class WayToGive {
  @Text({ label: 'Title', maxLength: 120, description: 'e.g. Online, By post.' })
  title!: string;
  /**
   * Markdown, with two tags of the site's own (the framework's directives — the same way
   * a sermon writes :verse[…]). One field rather than a field per part, so a way to give
   * says what it needs in the order it needs it:
   *
   *   :highlight[Zelle to give@acfi.cc]      the one line that is the instruction
   *   :::address                             an address, set as an address
   *   ACFI
   *   P.O. Box 5087
   *   :::
   */
  @Paragraph({
    label: 'Description', maxLength: 20000, rows: 6, markdown: true, allow: ['highlight', 'address'],
    description:
      'How it works. Put the one line people must not miss in :highlight[ … ], and an address '
      + 'between a line :::address and a line :::, one line of the address per line.',
  })
  blurb!: string;
  @RenderOf('blurb')
  blurbHtml!: string;
  @Img({
    label: 'Picture', folder: 'give', maxSizeMb: 12, size: '1000 × 1000 — the QR code alone',
    description: 'e.g. the Zelle QR code, cropped to the code. A click opens it full size, to scan.',
  })
  picture!: ImageValue;
  @Text({ label: 'Button text', maxLength: 120 })   ctaLabel!: string;
  @Link({ label: 'Button link', description: LINK_HINT }) ctaHref!: string;
}
